import { isProduction } from './env';

import type { PostHog } from 'posthog-js';

type PosthogCaptureController = Pick<PostHog, 'opt_out_capturing'>;

/**
 * Opts out of capturing outside production. In production it leaves the persisted opt-in/out state untouched,
 * so a cookie-consent refusal or an internal-user opt-out survives page reloads.
 */
export function applyPosthogEnvironmentCapture(posthog: PosthogCaptureController) {
  if (isProduction()) return;

  posthog.opt_out_capturing();
}
